<template lang="pug">
  vue-modal.v-modal(name='modal-premium-confirm', :adaptive="true", :classes='["v--modal", "u-overflow-y"]', width="100%", height="100%", @before-open="beforeOpen", @before-close="beforeClose")
    .p-global-header.p-global-header--no-shadow
      .grid-container.elastic-container
        .p-global-header__tom-logo
          a(@click="onClose") Tokyo Otaku Mode

    .grid-container(style='max-width: 640px; margin: 40px auto;')
      .row
        .col.s12.u-align-center
          img.c-tom-premium--inline(:src="'/images/tom_premium_h.svg' | staticImageUrl", alt='TOM Premium', style='height: 36px;')

      .row.u-mtm(v-if="route === 'index'")
        .col.s12
          .catch.u-align-center
            template(v-if="lang === 'ja'")
              template(v-if="premiumPlanPrice > 0") 入会金<strong class='v-gain'>{{ planPriceStr }}</strong>で
              template(v-else) 今なら初回入会30日間<strong class='v-gain'>無料</strong>、<br><span style="font-size: 75%;">さらに</span>
              | <span style="font-size: 75%;">ご注文金額から最大</span> <strong class='v-gain'>{{ savePriceStr }}</strong> 割引！
            template(v-else)
              template(v-if="premiumPlanPrice > 0")
                template(v-if="premiumPlanType === 'first'")= "Join for "
                template(v-else)= "Rejoin for "
                | <strong class='v-gain'>{{ planPriceStr }}</strong>
              template(v-else)
                | Get your first 30 days <strong class='v-gain'>FREE</strong>
              | <br />and save up to <strong class='v-gain'>{{ savePriceStr }}</strong> <br class="u-br--sm">on this order

          ul.u-fs-lg.c-list-check(style='max-width: 280px; margin: 0 auto;')
            template(v-if="lang === 'ja'")
              li(v-if="!(premiumPlanPrice > 0)") 初回入会<strong class="v-em">30日間無料</strong>
              li プレミアム会員<strong class="v-em">限定割引</strong>
              li <strong class="v-em">無期限</strong>ポイント
              li 更新時約<strong class="v-em">110%ポイント還元</strong>
            template(v-else)
              li(v-if="!(premiumPlanPrice > 0)") 30 day <strong class='v-em'>FREE trial</strong>
              li <strong class='v-em'>Exclusive</strong> shop discounts
              li TOM Points <strong class='v-em'>never expire</strong>
              li <strong class='v-em'>110% cash back</strong> for renewing

          .row.u-mtl(v-if='!canGetBonus')
            .col.s12
              .c-message.c-message--danger
                template(v-if="lang === 'ja'")
                  | この決済方法は既に別のアカウントで使用されています。この決済方法を利用した場合、TOMが提供するすべてのサービスの初回特典が得られないことをご了承ください。
                template(v-else)
                  | This payment method is already linked to another account. Please know any orders paid for by this payment method will not include first-time purchaser benefits of any kind in relation to TOM services.

          .row.u-mtl
            .col.l5.push-l6.s12
              button.c-btn.c-btn--lg.c-btn--action.c-btn--fill(type="button", @click="onSubmit")
                template(v-if="lang === 'ja'") {{ continueButtonLabels.ja || '入会して注文を確定する' }}
                template(v-else) {{ continueButtonLabels.en || 'Complete Your Order' }}
            .col.l4.offset-l1.pull-l4.s12.u-pts
              button.c-btn.c-btn--link.c-btn--fill(type="button", @click="onClose")
                template(v-if="lang === 'ja'") 今は入会しない
                template(v-else) Take me back

          .row.u-mtl
            .col.s12
              p.u-fs-sm
                template(v-if="lang === 'ja'")
                  template(v-if="premiumPlanType === 'first'")
                    | 入会契約して注文を確定されることで、お客様は<a href='#' @click.prevent='gotoTerms'>TOM Premium 利用規約</a>に同意の上入会されたことになります。<br />
                    | TOM Premium 会員の30日間の無料お試し期間の満了日に$14.99／90日間で自動更新されます。契約更新が完了すると更新毎に$16.50のTOMポイントを獲得できます。
                    | 契約の更新をキャンセルするためには、お客様のTOM プレミアム会員情報ページからいつでもキャンセルすることが可能です。
                  template(v-else)
                    | 入会契約して注文を確定されることで、お客様は<a href='#' @click.prevent='gotoTerms'>TOM Premium 利用規約</a>に同意の上入会されたことになります。TOM Premium 会員は90日間の契約が終了する7日前に$14.99／90日間で自動更新されます。契約更新が完了すると更新毎に$16.50のTOMポイントを獲得できます。契約の更新をキャンセルするためには、お客様のTOM プレミアム会員情報ページからいつでもキャンセルすることが可能です。
                template(v-else)
                  template(v-if="premiumPlanType === 'first'")
                    | By joining
                  template(v-else)
                    | By rejoining
                  | &nbsp;
                  | via this purchase, you agree to the <a href='#' @click.prevent='gotoTerms'>TOM Premium Terms & Conditions</a>.
                  | &nbsp;
                  template(v-if="premiumPlanType === 'first'")
                    | Your Premium subscription will AUTO-RENEW at $14.99 (for the next 90 days) on day 30 of your free trial.
                    | You may cancel an upcoming renewal any time by visiting Your TOM Premium Membership page.
                  template(v-else)
                    | Your Premium subscription will AUTO-RENEW at $14.99 on your scheduled billing date, 7 days prior to the completion of your first 90 day membership period. In exchange, you’ll receive $16.50 in TOM Points each time. You may cancel an upcoming renewal any time by visiting Your TOM Premium Membership page.

      .row.u-mtm(v-else-if="route === 'terms'")
        .col.s12
          iframe(width="100%", height="360px", :src="'/tos/premium?lang=' + lang")
          .u-mts
            button.c-btn.c-btn--link(type="button", @click="gotoIndex") Back

      hr
      .row
        .col.s12
          .u-color-muted.u-fs-sm
            template(v-if="lang === 'ja'") ご注文を確定されますと、お客様は当サイトの<a href='/tos' target='_blank'>利用規約</a>に同意の上、商品をご注文されたことになります
            template(v-else) By placing your order, you agree to Tokyo Otaku Mode's <a href='/tos' target='_blank'>terms of use</a> and <a href="/privacy_guide_checkout" target="_blank">privacy policy</a>.

</template>

<script>
import { default as urlUtil } from '../../util/url';
import { Currency } from '../../util/mixin/currency.mixin';

const ROUTE = {
  INDEX: 'index',
  TERMS: 'terms'
};

export default {
  name: 'premiumJoinConfirmModal',

  mixins: [Currency],

  props: {
    lang: {
      type: String,
      default: 'en'
    },

    savePrice: String
  },

  data() {
    return {
      route: ROUTE.INDEX,
      handler: null,
      closeHandler: null,
      continueButtonLabels: {}
    };
  },

  filters: {
    staticImageUrl: urlUtil.staticImageUrl
  },

  computed: {
    premium() {
      return this.$root.premium || this.$parent.premium;
    },
    premiumPlanType() {
      return (
        (this.premium != null ? this.premium.plan_type : undefined) ||
        this.$parent.premiumPlanType
      );
    },
    premiumPlanPrice() {
      return this.$root.premiumPlanPrice || this.$parent.premiumPlanPrice;
    },
    premiumPlanCurrency() {
      return (
        this.$root.premiumPlanCurrency ||
        this.$parent.premiumPlanCurrency ||
        'usd'
      );
    },
    premiumJoiningSavePrice() {
      return (
        this.$root.premiumJoiningSavePrice ||
        this.$parent.premiumJoiningSavePrice
      );
    },
    canGetBonus() {
      let left;
      return (left =
        this.$root.canGetBonus != null
          ? this.$root.canGetBonus
          : this.$parent.canGetBonus) != null
        ? left
        : true;
    },

    // body texts
    planPriceStr() {
      return this.formatCurrency(
        this.premiumPlanPrice,
        this.premiumPlanCurrency
      );
    },
    savePriceStr() {
      return (
        this.savePrice ||
        this.formatCurrency(
          this.premiumJoiningSavePrice,
          this.premiumPlanCurrency
        )
      );
    },

    pathname() {
      const path = '/cart';
      return path;
    }
  },

  methods: {
    beforeOpen(e) {
      if (e == null) {
        e = {};
      }
      $('html, body').css({ overflow: 'hidden' });
      this.handler = (e.params != null ? e.params.handler : undefined) || null;
      this.closeHandler =
        (e.params != null ? e.params.closeHandler : undefined) || null;
      this.continueButtonLabels =
        (e.params != null ? e.params.continueButtonLabels : undefined) || {};
    },

    beforeClose() {
      $('html, body').css({ overflow: 'auto' });
    },

    open(params) {
      if (params == null) {
        params = {};
      }
      this.$modal.show('modal-premium-confirm', params);
    },

    close() {
      this.$modal.hide('modal-premium-confirm');
    },

    onClose() {
      tom.helper.ga.push(['event', 'EC', 'Clicked', 'CloseConfirmPremium', 1]);
      if (this.closeHandler) {
        this.closeHandler();
      } else {
        this.close();
      }
    },

    onSubmit() {
      tom.helper.ga.push(['event', 'EC', 'Clicked', 'AgreeConfirmPremium', 1]);
      if (this.handler) {
        this.handler.apply();
      }
    },

    gotoIndex() {
      this.route = ROUTE.INDEX;
    },
    gotoTerms() {
      this.route = ROUTE.TERMS;
    }
  }
};
</script>

<style scoped>
.v-gain {
  color: #e83929;
}
.v-em {
  background: linear-gradient(transparent 75%, #f1cf00 25%);
}
</style>
